import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { GroupByType } from '../../../../components/GroupByType'
import { PlatformContext } from '../../../../components/context/platform'
import { sp } from '../../../../utils/platformSelect'

export const DownloadChart: React.FunctionComponent = ({ }) => {

    const platform = React.useContext(PlatformContext)
    const [groupBy, setGroupBy] = React.useState<string>('artist')
    const toolbarItems = GroupByType([
        { val: 'artist', display: 'Artist' },
        { val: sp(platform, { default: 'name', create: 'package_name' }), display: sp(platform, { default: 'Album', create: 'Sound Packs' }) }], groupBy, (selected) => {
            setGroupBy(selected!)
        }, false)

    return (
        <BPMChart title='Downloads' subTitle={'By ' + (groupBy == 'artist' ? 'Artists' : sp(platform, { default: 'Album', create: 'Sound Packs' }))} type='bar'
            key={groupBy}
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>(`search/downloads`, options, signal)
            }} additionalParams={{ groupBy, limit: 200 }} toolBarItems={() => toolbarItems}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            visualRangeEnd={10}
            series={{
                name: 'Downloads', valueField: 'count', argumentField: groupBy,
                smallValuesGrouping: { topCount: 10, mode: 'topN' }
            }} doesNotSupportQuery>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Search/charts/DownloadChart.tsx